import React, {useEffect, useState} from 'react';
import './Login.css';
import { PrimaryButton, Stack, TextField, Spinner, SpinnerSize } from '@fluentui/react';
import GetWithNoParams from '../../../Data/GetWithNoParams';
import InitialSetUp from './InitialSetUp/InitialSetUp';
import Post from '../../../Data/Post';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import {connect} from 'react-redux';
import * as actionTypes from '../../../store/actions';
import sedrilims_logo from '../../../assets/images/SEDRILIMS Logo.png';
import TranslateTag from '../../../Utils/Local/TranslateTag';


const userNameProp = { iconName: 'Contact' };
const passwordProp = { iconName: 'Lock' };
const columnProps = {
  tokens: { childrenGap: 15 },
  styles: { root: { minWidth: 300,
    horizontalAlign: 'center' } },
};

const rowProps = { 
  horizontal: true,
  verticalAlign: 'center'
};

const spinnerProps = {
  circle: {
    width: '100px',     // Adjust the width
    height: '100px',    // Adjust the height
    borderWidth: '10px' // Adjust the thickness
  }
};

const Login = (props) => {

  const [displaySetUpWindowState, setDisplaySetUpWindowState] = useState("No");
  const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
  const [fieldValues, updateFieldValues] = useState({username: '', password: ''});
  const [loginDisplay, setLoginDisplay] = useState("pending-submission");
  const [displayText, setDisplayText] = useState({usernameText: "Username", passwordText: "Password", establishingText: "Establishing",
                                                  authenticatingText: "Authenticating", loginText: "Login" });

  useEffect(() => {
//    GetWithNoParams("/setup/startupcheck",setDisplaySetUpWindowState)

    const startUpResponseReceived = (startUp) => {
      setDisplaySetUpWindowState(startUp.ConfigureSystem);
      let newDisplayText = {...displayText};
      newDisplayText.usernameText = startUp.UsernameText;
      newDisplayText.passwordText = startUp.PasswordText;
      newDisplayText.establishingText = startUp.EstablishingText;
      newDisplayText.authenticatingText = startUp.AuthenticatingText;
      newDisplayText.loginText = startUp.LoginText;
      setDisplayText(newDisplayText);
      props.setExpandedMenuKey('');
    }

    GetWithNoParams("/setup/startupcheck",startUpResponseReceived)
  },[/*props*/]);

  const closeSetupWindowHandler = () => {
    setDisplaySetUpWindowState("No");
  }

  const loginButtonClickHandler = () => {
    errorCloseHandler();
    Post('auth/login',fieldValues,loggedInSuccessfully, errorWhenLoggingIn )
    setLoginDisplay("pending-authentication");
  }

  const loggedInSuccessfully = (token) => {
    localStorage.setItem("arctoken", token.token);  
    GetWithNoParams('/config/get',configRetrievedSuccessfully, errorWhenLoggingIn, token.token);
    setLoginDisplay("pending-configuration");
  }

  const configRetrievedSuccessfully = (configData) => {
    props.successfulLogin(configData, fieldValues);
    setLoginDisplay("finished");
  }

  const errorWhenLoggingIn = (response) => {
    localStorage.setItem("arctoken", "");
    updateErrorStatus({visible: true, message: response.data === undefined ? response : response.data});
    setLoginDisplay("pending-submission");
  }

  const errorCloseHandler = () => {
    updateErrorStatus({visible: false, message: ''});
  }

  const storeUsername = (event) => {
    let newFields = {...fieldValues};
    newFields.username = event.target.value;
    updateFieldValues(newFields)
  }

  const storePassword = (event) => {
    let newFields = {...fieldValues};
    newFields.password = event.target.value;
    updateFieldValues(newFields)
  }

  let credentials = (null);
  if (loginDisplay === "pending-submission" || loginDisplay === "pending-authentication") {
    credentials = (
      <div>
        <TextField data-test="username" label={displayText.usernameText} required iconProps={userNameProp} onChange={storeUsername} styles={{subComponentStyles: {label: {root: {color: "purple"}}}}}/>
        <TextField data-test="password" label={displayText.passwordText} type="password" required iconProps={passwordProp} onChange={storePassword} styles={{subComponentStyles: {label: {root: {color: "purple"}}}}}/>
      </div>
    )
  }

  let progressMessage = (null);
  if (!errorStatus.visible) {
    if (loginDisplay === "pending-configuration") {
      progressMessage = (
        <div className="login-spinner-text">{displayText.establishingText}...</div>
      )
    }
    else if (loginDisplay === "pending-authentication") {
      progressMessage = (
        <div className="login-spinner-text">{displayText.authenticatingText}...</div>
      )
    }
  }

  let submitButton = (null);
  if (loginDisplay === "pending-submission") {
    submitButton = (
        <PrimaryButton data-test="login" text={displayText.loginText} onClick={loginButtonClickHandler}/>
      )
  }

  let spinner = (null);
  if (!errorStatus.visible && (loginDisplay === "pending-authentication" || loginDisplay === "pending-configuration")) {
    spinner = (
      <Spinner styles={spinnerProps}/>
    )
  }

  if (displaySetUpWindowState === "Yes") {
    return (
      <InitialSetUp closeWindowHandler={closeSetupWindowHandler}></InitialSetUp>
    )
  } else {
    return (
      <div className="login-content">
        <div className="login-logo">
          <img src={sedrilims_logo} alt="Sedric Logo" height="100%"/>
        </div>
        <Stack {...columnProps}>
          {credentials}
          {progressMessage}
          <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
          {submitButton}
          {spinner}
        </Stack>
        <div className="login-footer">
          Version 2.2.0
        </div>
      </div>
    )
  }
};


const mapStateToProps = state => {
  return {
      expandedMenuKey: state.display.expandedMenuItem
  };
}

const mapDispatchToProps = dispatch => {
  return {
      setExpandedMenuKey: (value) => dispatch({type: actionTypes.SETEXPANDEDMENUITEM, value: value})
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
